import { render, staticRenderFns } from "./door.vue?vue&type=template&id=7b96ce6a&"
import script from "./door.vue?vue&type=script&setup=true&lang=js&"
export * from "./door.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports